class FeaturedProductExtended {
  constructor() {
    this.featuredProductExtendedElements = document.querySelectorAll('.featured-product-extended');
    this.init();
  }

  init(){
    this.hideElementsExceptFirst();
    this.addClickEventToVariantPicker();
  }

  hideElementsExceptFirst() {
    if (this.featuredProductExtendedElements.length > 0) {
      Array.prototype.slice.call(this.featuredProductExtendedElements, 1).forEach(element => {
        element.querySelector('.section').style.display = 'none';
      });
    } else {
      console.log('No elements with class "featured-product-extended" found.');
    }
  }

  addClickEventToVariantPicker() {
    this.featuredProductExtendedElements.forEach(element => {
      const container = element.querySelector('.section ').dataset.productHandle;
      const variantPicker = element.querySelector('.product-info__variant-picker');
      if (variantPicker) {
        const links = variantPicker.querySelectorAll('a');
        links.forEach(link => {
          link.addEventListener('click', (e) => {
            e.preventDefault();
            const href = link.getAttribute('href');
            const handle = href.split('/').pop();
            if(container != handle){
              this.sectionChecker(handle, href);
            }
          });
        });
      }
    });
  }

  sectionChecker(handle, href){
    const transferElement = document.querySelector(`.section[data-product-handle="${handle}"]`);
    if(transferElement){
      this.featuredProductExtendedElements.forEach(element => {
        element.querySelector('.section').style.display = 'none';
      });
      transferElement.style.display = 'block';
      transferElement.scrollIntoView({
        block: 'start'
      });
    }else{
      window.location.href = href;
    }
  }
}

// Initialize the class
new FeaturedProductExtended();